import React from 'react'
import { Button } from 'react-bootstrap';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

/**
 * Exports json data to a csv file and opens the browsers download dialog.
 * Export code adapted from the xlsx company's github: https://github.com/SheetJS/sheetjs/blob/master/demos/react/sheetjs.js
 * @param {boolean} disabled used for determing if the button should be disabled
 * @param {string[]} csvData string array in json format, containing the data to be exported
 * @param {string} fileName string for naming the downloadable csv
*/
const ExportCSV = ({ disabled, csvData, fileName, isTransaction = false }) => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    const fileExtension = '.xlsx';

    const exportToCSV = (csvData, fileName) => {
        console.log("exportToCSV")
        console.log(isTransaction)
        console.log(csvData)
        if (isTransaction === true) {
            const wb = { Sheets: { }, SheetNames: [] }
            csvData.forEach(x => {
                const ws = XLSX.utils.json_to_sheet((x))
                const sizeCat = x[0]['Größenkategorie'].toString() + " "
                wb.SheetNames.push(sizeCat)
                wb.Sheets[sizeCat] = ws
            })
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
            const data = new Blob([excelBuffer], { type: fileType })
            FileSaver.saveAs(data, fileName + fileExtension)
        } else {
            const ws = XLSX.utils.json_to_sheet((csvData))
            const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] }
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
            const data = new Blob([excelBuffer], { type: fileType })
            FileSaver.saveAs(data, fileName + fileExtension)
        }
    }

    return (
        <Button lang="de" className="exportButton form filter-button form-control" disabled={disabled} variant="light" onClick={(e) => exportToCSV(csvData, fileName)}>Export</Button>
    )
}

export { ExportCSV }